<template>
    <b-modal
        :id="`modal-preview-${$parent.modalItemName}`"
        ref="modal"
        :title="$t('transactions.productsList')"
        size="xl"
        :hide-footer="true"
    >
        <template v-if="item">
            <p class="sub-header">
                {{ $t('transactions.productsListTransaction', { id: item.transId, campaign: item.campaign.name }) }}
            </p>
            <div v-if="item.abpar1 || item.abpar2 || item.abpar3" class="mb-4">
                <Ellipsis v-if="item.abpar1" :max-width="200" :max-lines="1"><strong>Abpar 1:</strong> {{ item.abpar1 }}</Ellipsis>
                <Ellipsis v-if="item.abpar2" :max-width="200" :max-lines="1"><strong>Abpar 2:</strong> {{ item.abpar2 }}</Ellipsis>
                <Ellipsis v-if="item.abpar3" :max-width="200" :max-lines="1"><strong>Abpar 3:</strong> {{ item.abpar3 }}</Ellipsis>
            </div>
            <b-table
                hover
                :items="item.items"
                :fields="fields"
                show-empty
                :empty-text="$t('noResult')"
                foot-clone
                no-footer-sorting
            >
                <template #cell(name)="data">
                    <a :href="data.item.url" target="_blank">{{ data.value || $t('transactions.productNoInfo') }}</a>
                </template>
                <template #cell(amount)="data">
                    {{ $format.currency(data.value) }}
                </template>
                <template #cell(commission)="data">
                    <div>{{ $t('transactions.commissions.publisher') }}: {{ $format.currency(data.item.publisherCommission) }}</div>
                    <div>{{ $t('transactions.commissions.admin') }}: {{ $format.currency(data.item.adminCommission) }}</div>
                    <div>{{ $t('transactions.commissions.advertiser') }}: {{ $format.currency(data.item.advertiserCommission) }}</div>
                </template>
                <template #foot(name)>
                    {{ $t('transactions.total') }}
                </template>
                <template #foot(quantity)>
                    {{ sumBy(item.items, 'quantity') }}
                </template>
                <template #foot(amount)>
                    {{ $format.currency(sumBy(item.items, 'amount')) }}
                </template>
                <template #foot(commission)>
                    <div>{{ $t('transactions.commissions.publisher') }}: {{ $format.currency(sumBy(item.items, 'publisherCommission')) }}</div>
                    <div>{{ $t('transactions.commissions.admin') }}: {{ $format.currency(sumBy(item.items, 'adminCommission')) }}</div>
                    <div>{{ $t('transactions.commissions.advertiser') }}: {{ $format.currency(sumBy(item.items, 'advertiserCommission')) }}</div>
                </template>
            </b-table>
        </template>
    </b-modal>
</template>



<script>
    import sumBy from 'lodash/sumBy';
    import Ellipsis from '@/components/common/Ellipsis.vue';

    export default {
        name: 'ItemPreview',
        components: {
            Ellipsis,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                item: null,
            };
        },
        computed: {
            fields() {
                return [
                    {
                        key: 'name',
                        label: this.$t('transactions.productName'),
                        sortable: true,
                    },
                    {
                        key: 'quantity',
                        label: this.$t('transactions.quantity'),
                        sortable: true,
                    },
                    {
                        key: 'amount',
                        label: this.$t('value'),
                        sortable: true,
                        tdClass: 'text-right text-nowrap',
                        thClass: 'text-right',
                    },
                    {
                        key: 'commission',
                        label: this.$t('commission'),
                        sortable: true,
                        tdClass: 'text-right text-nowrap',
                        thClass: 'text-right',
                    },
                ];
            },
        },
        methods: {
            sumBy,
            onItem(item) {
                this.item = item;
            },
        },
        mounted() {
            this.$root.$on(`preview-${this.parentComponent.modalItemName}`, this.onItem);
        },
        beforeDestroy() {
            this.$root.$off(`preview-${this.parentComponent.modalItemName}`, this.onItem);
        },
    };
</script>
